import { aboutContent } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            {aboutContent.title}
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            {aboutContent.paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>

          <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6">
            {aboutContent.highlights.map((h, i) => (
              <div key={i} className="text-center p-4 rounded-xl bg-background-100 border border-background-200/70">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                  <i className={`${h.icon} text-lg`}></i>
                </div>
                <div className="mt-3 text-xl md:text-2xl font-heading font-bold text-foreground-900">
                  {h.label}
                </div>
                <div className="mt-1 text-xs text-foreground-500">{h.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}